import React, { useState, useEffect, useRef } from "react";
import {
  getCurrentUser,
  signInWithRedirect,
  fetchAuthSession,
  fetchUserAttributes,
} from "aws-amplify/auth";

function useAutoRefreshToken() {
  useEffect(() => {
    const intervalId = setInterval(async () => {
      try {
        const session = await fetchAuthSession({ forceRefresh: true });
        const exp =
          (session as any)?.tokens?.accessToken?.payload?.exp ??
          Math.floor(Date.now() / 1000);

        const expiresInMs = exp * 1000 - Date.now();
        console.log("Token expires in(ms):", expiresInMs);
      } catch (error) {
        console.error("Failed to refresh token:", error);
      }
    }, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);
}
export default function AuthGate({ children }: { children: React.ReactNode }) {
  useAutoRefreshToken();
  const [ready, setReady] = useState(false);
  const redirectingRef = useRef(false);
  const w = globalThis.window;
  useEffect(() => {
    async function checkAuth() {
      try {
        if (w && /[?&](code|error)=/.test(w.location.search)) {
          await fetchAuthSession();
          w.history.replaceState(null, "", w.location.pathname);
        }
        await getCurrentUser();
        await fetchUserAttributes();

        sessionStorage.removeItem("amplify:signin:inprogress");
        setReady(true);
      } catch (err) {
        if (
          !redirectingRef.current &&
          sessionStorage.getItem("amplify:signin:inprogress") !== "1"
        ) {
          redirectingRef.current = true;
          sessionStorage.setItem("amplify:signin:inprogress", "1");
          await signInWithRedirect();
        } else {
          setReady(true);
        }
      }
    }
    checkAuth();
  }, []);

  if (!ready)
    return <div className="text-white p-4">Loading authentication…</div>;
  return <>{children}</>;
}
